var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.118 20.0825C19.0136 20.0825 18.9092 20.0427 18.8296 19.963L8.59312 9.72488C8.4338 9.56557 8.4338 9.30742 8.59312 9.1481C8.75244 8.98879 9.0106 8.98879 9.16964 9.1481L19.4059 19.3865C19.5652 19.5458 19.5652 19.8039 19.4059 19.9632C19.3266 20.0425 19.2222 20.0825 19.118 20.0825Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88152 20.0825C8.77708 20.0825 8.67292 20.0427 8.59312 19.9632C8.4338 19.8039 8.4338 19.5458 8.59312 19.3865L18.8319 9.1481C18.9912 8.98879 19.2491 8.98879 19.4084 9.1481C19.5677 9.30742 19.5677 9.56557 19.4084 9.72488L9.16964 19.9632C9.09012 20.0425 8.98596 20.0825 8.88152 20.0825Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0022 28C6.28124 28 0 21.7204 0 14.0017C0 6.28127 6.28124 0 14.0022 0C21.7207 0 28 6.28127 28 14.0017C28 21.7201 21.7207 28 14.0022 28ZM14.0022 0.815327C6.73092 0.815327 0.81564 6.73065 0.81564 14.0014C0.81564 21.2705 6.7312 27.1841 14.0022 27.1841C21.271 27.1841 27.1844 21.2702 27.1844 14.0014C27.1846 6.73065 21.271 0.815327 14.0022 0.815327Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/CloseIcon.b84eae882e54a811426852eee2f2708e.svg";
export { ForwardRef as ReactComponent };